import React from 'react';

import './MainSectionLiveVideo.scss';
import { Project } from '../../../types/Project';
import { UserTypeEnum } from '../../../types/enums/UserTypesEnum';

type MainSectionLiveVideoProps = {
  project?: Project;
  userType: UserTypeEnum | undefined;
  streamIso: string;
};

const MainSectionLiveVideo = ({ project, userType, streamIso }: MainSectionLiveVideoProps) => {
  const selectedIso = streamIso ?? project?.encoder.languageIsoCode;

  return (
    <iframe
      title="Livestream Video"
      width="100%"
      height="100%"
      src={`/libs/player.html?host=${project?.stream?.streamUrl
        .replace('rtmps://', '')
        .replace('/live/', '')
        .replace('/live', '')}&key=${project?.stream?.streamKey}&userType=${userType}&iso=${selectedIso}`}
      allowFullScreen
    ></iframe>
  );
};

export default MainSectionLiveVideo;
